import { LanguageTestSubmissionStep } from '../../../../lib/types/enums/language-test-submissions/language-test-submission-step'
import useLanguageTest from '../../../../views/client-personal-space/informations/context/use-language-test'
import LanguageTestInstructions from './language-test-instructions'
import LanguageTestLoading from './language-test-loading'
import LanguageTestSections from './language-test-sections'
import LanguageTestSubmitted from './language-test-submitted'

const LanguageTestRender = () => {
  const { step } = useLanguageTest()

  switch (step) {
    case LanguageTestSubmissionStep.CHECKING_ACTIVE_SUBMISSION:
      return <LanguageTestLoading />

    // LOCKED shows the instructions page with the start button disabled
    case LanguageTestSubmissionStep.LOCKED:
    case LanguageTestSubmissionStep.DISPLAY_INSTRUCTIONS:
      return <LanguageTestInstructions />

    case LanguageTestSubmissionStep.DISPLAY_TEST_SECTION:
      return <LanguageTestSections />

    case LanguageTestSubmissionStep.TEST_SUBMITTED:
      return <LanguageTestSubmitted />
  }
}

export default LanguageTestRender
